export const base64ToUint8Array = (base64) => {
  if (typeof base64 !== 'string') {
    throw new TypeError('base64ToUint8Array expected a base64 string')
  }
  const cleanBase64 = base64.includes(',') ? base64.split(',')[1] : base64
  const binaryString = atob(cleanBase64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}
